// extracted by mini-css-extract-plugin
export default {"recos":"P3-z","productCardOverride":"Q3-z","rowHasBadge":"R3-z"};